/**
 * Fera ratings client. Fera's public API only allows browser calls from the
 * shop's own origin, so we proxy through a Netlify function that does the
 * two-step product-lookup + reviews-aggregate dance server-side.
 */

export interface FeraRating {
  rating: number
  count:  number
}

const PROXY_ENDPOINT = '/.netlify/functions/fera-rating'

export async function fetchFeraRating(shopifyProductId: string | number): Promise<FeraRating | null> {
  try {
    const url = `${PROXY_ENDPOINT}?external_id=${encodeURIComponent(String(shopifyProductId))}`
    const res = await fetch(url)
    if (!res.ok) {
      console.warn('[fitquiz][fera] proxy returned non-ok', shopifyProductId, res.status)
      return null
    }
    const body = (await res.json()) as { ok: boolean; rating?: number; count?: number }
    if (!body.ok || typeof body.rating !== 'number' || typeof body.count !== 'number') {
      return null
    }
    return { rating: body.rating, count: body.count }
  } catch (err) {
    console.warn('[fitquiz][fera] proxy fetch error', shopifyProductId, err)
    return null
  }
}
